module.exports = __webpack_public_path__ + "static/img/zhufang.4952ad58.png";